var _path;

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

function SvgLinkedininline(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M4.832 3.81c1.027 0 1.86-.853 1.86-1.905S5.86 0 4.832 0c-1.027 0-1.86.853-1.86 1.905s.833 1.905 1.86 1.905zM6.347 5.333h-3a.378.378 0 00-.375.381v9.905c0 .21.168.381.375.381h3c.207 0 .375-.17.375-.381V5.714c0-.21-.168-.38-.375-.38zM17.597 16h-2.25c-.1 0-.195-.04-.265-.112a.384.384 0 01-.11-.269V9.905c0-.505-.197-.99-.549-1.347A1.86 1.86 0 0013.097 8c-.497 0-.974.2-1.326.558a1.92 1.92 0 00-.549 1.347v5.714c0 .101-.04.198-.11.27a.372.372 0 01-.265.111h-2.25c-.1 0-.195-.04-.265-.112a.384.384 0 01-.11-.269V5.714c0-.1.04-.198.11-.27a.372.372 0 01.265-.11h2.25c.1 0 .195.04.265.11.07.072.11.17.11.27a.315.315 0 00.2.294.303.303 0 00.34-.088 3.155 3.155 0 011.088-.74c.41-.166.849-.244 1.29-.228 2.235 0 3.832 1.395 3.832 4.267v6.4c0 .101-.04.198-.11.27a.372.372 0 01-.265.111z",
    fill: "#fff"
  })));
}

export default SvgLinkedininline;